<template>
  <div class="basic-info">
    <van-field
      class="flex-center"
      v-model.trim="userInfoInput.name"
      type="text"
      label="真实姓名"
      clearable
      placeholder="请输入姓名"
      maxlength="20"
      label-class="justify-lable"
    />
    <van-field
      class="flex-center"
      v-model.trim="userInfoInput.card"
      type="text"
      label="身份证号"
      clearable
      placeholder="请输入身份证号"
      maxlength="18"
      label-class="justify-lable"
      :formatter="$util.toString"
    />

    <van-cell class="flex-center" title="性别" title-class="justify-lable" title-style="width:90px;flex:none">
      <template>
        <van-radio-group v-model="userInfoInput.sex" class="flex-between gender-box">
          <van-radio name="1" class="pull-left gender-item">
            <i slot="icon" class="iconfont iconicon_male1 male" :class="{ active: userInfoInput.sex == 1 }" />
            <span class="male" :class="{ active: userInfoInput.sex == 1 }">男</span>
          </van-radio>
          <i class="split-line"></i>
          <van-radio name="2" class="pull-right gender-item">
            <i slot="icon" class="iconfont iconicon_female female" :class="{ active: userInfoInput.sex == 2 }" />
            <span class="female" :class="{ active: userInfoInput.sex == 2 }">女</span>
          </van-radio>
        </van-radio-group>
      </template>
    </van-cell>

    <!-- <van-field v-model="birthday" type="text" label="出生日期" readonly /> -->
    <van-field
      v-model="addressValueInput"
      type="text"
      class="region-in flex-center"
      label="所在地区"
      placeholder="省-市"
      readonly
      @click="showAreaPicker = true"
    />

    <van-action-sheet v-model="showAreaPicker" :round="false">
      <van-area
        :area-list="areaList"
        columns-num="2"
        @confirm="setAdd"
        @cancel="handleCancel"
        :value="userInfoInput.districtCode"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import area from '@/assets/js/area.js';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  name: 'BindingBasicInfo',
  data() {
    return {
      userInfoInput: {
        name: '',
        sex: '',
        card: '',
        districtCode: '',
        city: '',
        province: ''
      },
      areaList: area,
      showAreaPicker: false,
      addressValueInput: '',

    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['addressValue'])
  },
  watch: {
    userInfo: {
      handler(newVal) {

        // 如果从IM实名过来 置灰提交按钮
        const { prescriptionId, from } = this.$route.query;
        const { card, name } = newVal;

        if (card && name && prescriptionId && from) {

          this.$emit('submit', { prescriptionId, from, userInfo: newVal });
        }
        this.userInfoInput = this.$util.clone(newVal);

      },
      deep: true,
      immediate: true
    },

    userInfoInput: {
      handler(newVal) {
        this.$emit('updUserInfo', {
          ...newVal
        });
      },
      deep: true,
      immediate: true
    },
    addressValue: {
      handler(val) {
        this.addressValueInput = val;
      },
      immediate: true
    }
  },
  components: {},
  methods: {
    ...mapActions(['getUserInfo']),
    setAdd(valArray) {
      const add = valArray.reduce((acc, val, index) => {
        const name = index == 0 ? val.name : '-' + val.name;
        if (acc != val.name) {
          return acc + name;
        } else {
          return acc;
        }
      }, '');

      const location = {
        districtCode: valArray[1].code,
        city: valArray[1].name,
        province: valArray[0].name
      };
      this.userInfoInput = {
        ...this.userInfoInput,
        ...location
      };

      this.addressValueInput = add;
      this.showAreaPicker = false;
    },
    handleCancel() {
      this.showAreaPicker = false;
    }
  }
};
</script>

<style scoped lang="scss">
.flex-center {
  ::v-deep .van-cell__flexrow {
    .van-cell__flexbox {
      width: 100%;
      align-items: center;
    }
  }
}
.gender-box {
  width: 180px;
}
.gender-item {
  /* width: 90px; */
}
.split-line {
  display: inline-block;
  width: 1px;
  height: 24px;
  background: #e6e6e6;
}
.cell-content {
  text-align: left;
  color: #333;
}
.male.active {
  color: #1e8dff;
}
.female.active {
  color: #fc6b53;
}

::v-deep .region-in {
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #ccc;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ccc;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #ccc;
  }
}
</style>
